import type { ContactFormPayload, ContactFormResponse } from '@/types/cta';
import { API_BASE_URL } from '@/lib/apiBase';

const CONTACT_PATH = '/contact';

export async function submitContactForm(
  payload: ContactFormPayload,
): Promise<ContactFormResponse> {
  const response = await fetch(`${API_BASE_URL}${CONTACT_PATH}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const body = (await response.json()) as ContactFormResponse | { error?: string };
  if (!response.ok) {
    throw new Error(body && 'error' in body ? body.error ?? 'Request failed' : 'Request failed');
  }

  return body as ContactFormResponse;
}
